// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"607":"ai-assistant-popup","1395":"tc-inner","3353":"contact","6194":"lightSlider","8332":"fxEcalendar","9459":"InstrumentsPagerates"}[chunkId] || chunkId) + ".css";
};